export default "/images/vendor/flag-icon-css/flags/4x3/pa.svg?8788ab50de263793f74b85d2e6eaba5c";